// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__3GVHk","linkText":"Link_link-text___lTP3"};